 import { RoleType } from "../types/role";
import { createApiStore } from "./genericStore";
 
export const useRoleStore = createApiStore<RoleType>("/role");
